import { Button } from '@/components/elements/forms/buttons';
import Icon from '@/components/icons/Icon';
import { _t } from '@/locale';

const baseTranslationKey = 'features.deals.components.SearchWithoutDeal' as const;

const SearchWithoutDeal = ({ onCTAClick, onClearFilters }: { onCTAClick: () => void; onClearFilters?: () => void }) => {
  return (
    <section className="p-2xl gap-2xl flex flex-col items-center text-center">
      {onClearFilters ? (
        <p className="text-fg_secondary text-xl">
          {_t(`${baseTranslationKey}.filterApplied.prefix`)}{' '}
          <button className="text-fg_link underline" onClick={onClearFilters}>
            {_t(`${baseTranslationKey}.filterApplied.clearFilter`)}
          </button>{' '}
          {_t(`${baseTranslationKey}.filterApplied.suffix`)}
        </p>
      ) : (
        <p className="text-fg_secondary text-xl">{_t(`${baseTranslationKey}.description`)}</p>
      )}
      <Button
        className="flex-shrink-0"
        variant="primary"
        size="lg"
        leftIcon={<Icon variant="search" />}
        onClick={onCTAClick}>
        {_t(`${baseTranslationKey}.cta`)}
      </Button>
    </section>
  );
};

export default SearchWithoutDeal;
